import React from "react";

import { GlobalLocationState } from "../../../../commons/types/location";

import { useAppHistory, useAppLocation } from "./use-app-routing";

const useRestoreScrollPosition = (scrollRef: React.RefObject<HTMLElement | null>, shouldRestore: boolean = true) => {
  const history = useAppHistory();
  const location = useAppLocation();

  const [didRestoreScroll, setDidRestoreScroll] = React.useState(false);

  const onPushAndStoreScrollPosition = (pushLocation: string, state?: GlobalLocationState) => {
    const scrollElement = scrollRef.current;
    const scrollPosition = scrollElement?.scrollTop ?? 0;

    // Use a replace to push the state on the stack
    history.replace([location.pathname, location.search, location.hash].join(""), {
      ...(location.state || {}),
      scrollPosition
    });

    history.push(pushLocation, state);
  };

  React.useEffect(() => {
    if (!didRestoreScroll && shouldRestore) {
      const scrollElement = scrollRef.current;

      if (location.state?.scrollPosition && scrollElement) {
        scrollElement.scrollTop = location.state?.scrollPosition;
        setDidRestoreScroll(true);
      }
    }
  }, [didRestoreScroll, location.state?.scrollPosition, scrollRef, shouldRestore]);

  return onPushAndStoreScrollPosition;
};

export default useRestoreScrollPosition;
